<template>
  <v-row v-if="!isComponentLoading" no-gutters>
    <v-col cols="12">
      <div class="d-flex justify-end">
        <v-menu offset-y>
          <template #activator="{ on, attrs }">
            <v-icon size="28" color="black" class="px-2 py-1" v-bind="attrs" v-on="on">mdi-export</v-icon>
          </template>

          <v-list rounded outlined>
            <v-list-item class="list-item" @click="donwloadDataCSV()">
              <v-list-item-title>Exporter au format CSV</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item" @click="downloadDataPDF()">
              <v-list-item-title>Exporter au format PDF</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <ResourceHorseListHeader :headers="headers" />
      <!-- drag and drop cavaliers and horses -->
      <div style="height:544px;" class="overflow-y-auto d-flex flex-column redScroll">
        <div
          v-for="(value, index) in getNormalResources"
          :key="`participant_horse_list_${index}`"
        >
          <div class="d-flex flex-column align-center">
            <ResourceHorseListItem 
              class="participantHorseList"
              :key="`participant_horse_list_item_${index}`"
              :content="value" 
              :index="getResourcesTrueIndex(value)" 
              :participants="computedSessionParticipants" 
              :horses="horses" 
              :available-horses="getAvailableHorses" 
              :session="session" 
              :selected-participants="participantsSelected" 
              :selected-horses="horsesSelected" 
              :is-club-expanded="isClubExpanded"
              :calculate-customer-age="customerAge"
              :number-of-club-participants="getClubParticipants(value).length"
              @toggle-expansion="toggleClubParticipantsExpansion"
            />

            <div v-if="isClubExpanded(value.contract_number)" class="col-12 d-flex flex-column align-center pa-0">
              <ResourceHorseListItem
                v-for="(clubParticipant, clubParticipantIndex) in getClubParticipants(value)"
                class="clubParticipantHorseList"
                :key="`participant_horse_list_item_club_participant_${clubParticipantIndex}`"
                :content="clubParticipant" 
                :index="getResourcesTrueIndex(clubParticipant)" 
                :participants="computedSessionParticipants" 
                :horses="horses" 
                :available-horses="getAvailableHorses" 
                :session="session" 
                :selected-participants="participantsSelected" 
                :selected-horses="horsesSelected"
                :number-of-club-participants="getClubParticipants(value).length"
                :calculate-customer-age="customerAge"
              />
            </div>
          </div>
          <v-divider />
        </div>
        <!-- DIVIDER -->
        <div class="d-flex align-center justify-center preReservedSeparator" style="height:46px;">
          <p class="mb-0">Participants en pré réservation ({{ preReservedParticipants.length }})</p>
        </div>
        <!-- PRE RESEREVED -->
        <div
          v-for="(value, index) in preReservedParticipants"
          :key="`pre_reserved_participants_${index}`"
          class="preReservedParticipant"
        >
          <v-row class="align-center pa-2" no-gutters>
            <v-col cols="6" align-self="center">
              {{ value.fullname }}
            </v-col>
            <v-col cols="6" align-self="center">
              <v-btn small icon @click="removePreOrder(value)"><v-icon color="third">mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <v-divider />
    </v-col>
    <v-container>
      <v-col cols="12" class="d-inline-block py-0 padding-12">
        <!-- extract to component table footer ? -->
        <v-col :cols="isEquestrianSession ? 4 : 12" class="d-inline-block">
          <!-- cavaliers -->
          <TablePopUp
            v-if="canUserPerformAction"
            v-model="participantsSelected"
            :class="[{'disable':!!session.cancelled}]"
            :list="customersWithoutSession"
            icon="mdi-account-plus"
            field="fullname"
            wtype="participant"
            :participant-horse-list.sync="participantHorseList"
            activator-text="Ajouter un participant"
            width="550"
            content-type-id-field="uuid"
            :session="session"
            :disabled="!canUserPerformAction"
          />
        </v-col>
        <v-col v-if="isEquestrianSession" cols="4" class="d-inline-block">
          <!-- <v-row no-gutters class="justify-center">
            <div v-for="(status, index) in paymentStatus" :key="`payment_${index}`" class="d-flex align-center">
              <div :style="status.style" class="box-payment-status"></div>
              <span class="mx-1">{{ status.label }}</span>
            </div>
          </v-row> -->
        </v-col>
        <v-col v-if="isEquestrianSession" cols="4" class="d-inline-block">
          <!-- Horses -->
          <TablePopUp
            v-if="canUserPerformAction && isEquestrianSession"
            v-model="horsesSelected"
            :class="[{'disable':!!session.cancelled}]"
            :list="getAvailableHorses"
            icon="mdi-plus"
            field="horse_name"
            wtype="horse"
            :participant-horse-list.sync="participantHorseList"
            activator-text="Ajouter un cheval"
            width="550"
            :session="session"
            content-type-id-field="uuid"
            :disabled="!canUserPerformAction"
          />
        </v-col>
        <!-- end extract to component -->
      </v-col>
    </v-container>
    <SessionEditOverlay
    v-if="session.recurring && showConfirmationModal"
    :activator.sync="showConfirmationModal"
    :change-confirmation-modal="changeEditSessionOverlay"
    :change-recurring-session="manageContents"
    :options="editOverlayOptions"
    :typeOfAction.sync="typeOfAction"
    :contentType.sync="updateParams.contentType"
  />
  </v-row>
  <div v-else class="d-flex justify-center align-center full-height min-height350">
    <Loader />
  </div>

</template>

<script>
import { ref, computed, provide, watch, onBeforeMount } from '@vue/composition-api';
import { format, fromUnixTime, differenceInYears } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import { availableHorses, separateContentTypesWithAndWithoutSession, filterHorse } from '@/helpers/dataManager';
import { updateSessionAmplify, removePreReservations, sessionsByRecurringUuid, addHorsesToSession } from '../../helpers/amplify';
import TablePopUp from '../TablePopUp.vue';
import { downloadCSV, deleteOptions, presentAndFutureOptions } from '@/helpers/utils';
import downloadSessionPDF from '@/helpers/pdf';
import { equestrianSession, recurringHorseAssignSessions, sessionsWithPeriods, constructSessionsBag } from '@/helpers/sessions';

import ResourceHorseListHeader from '../resourceHorseList/ResourceHorseListHeader.vue';
import ResourceHorseListItem from '../resourceHorseList/ResourceHorseListItem.vue';
import Loader from '@/components/common/Loader.vue';
import SessionEditOverlay from '../sessions/createForm/SessionEditOverlay.vue';
import store from '@/store';
import { sendNotification, sortArray } from '../../helpers/utils';
import { getCustomersByUUids } from '@/helpers/request';

const paymentStatus = require('@/configs/paymentStatus.json');

export default {
  components: {
    TablePopUp,
    ResourceHorseListHeader,
    Loader,
    ResourceHorseListItem,
    SessionEditOverlay
  },
  props: {
    session: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const participantsSelected = ref([]);
    const horsesSelected = ref([]);
    const participantHorseList = ref([]);
    const participantHorse = ref([]);
    const isComponentLoading = ref(false);
    // const customerStatus = ref(null);
    const customersDetails = ref(null);

    const horseWithoutParticipant = ref(null);
    const selectedHorseTypes = ref([]);
    const horses = computed(() => store.state.horses);
    const selectedLevels = ref([]);

    const typeOfUpdate = ref('SINGLE');
    const typeOfAction = ref(null);
    const updateParams = ref({});
    const showConfirmationModal = ref(false);

    const participantAmount = computed(() => participantHorseList.value.filter(p => !!p.participant && !p.notInSession).length);
    const horseAmount = computed(() => participantHorseList.value.filter(p => !!p.horse).length);

    const isEquestrianSession = computed(() => equestrianSession(props.session.type));

    const canAssignHorsesRecurring = computed(() => recurringHorseAssignSessions.includes(props.session.type));

    const horseAssignRecurringAutoAction = computed(() => store.state.autoActionFlags.horseAssignRecurring);

    const editOverlayOptions = computed(() => {
      if (typeOfAction.value === 'add') {
        return presentAndFutureOptions;
      }
      return deleteOptions;
    });

    const changeEditSessionOverlay = value => {
      showConfirmationModal.value = value;
    };

    const headers = computed(() => {
      if(isEquestrianSession.value) {
        return [
          { label: 'Cavaliers', icon: 'mdi-horse-human', key: 'participant', canShow: true, showCounter: true, counter: participantAmount.value, cols: 6 },
          { isDivider: true, canShow: true, cols: 1 },
          { label: 'Chevaux', icon: 'mdi-horse', key: 'horse', canShow: true, showCounter: true, counter: horseAmount.value, cols: 5 }
        ];
      }
      return [
        { label: 'Participants', icon: 'mdi-account-outline', key: 'participant', canShow: true, showCounter: true, counter: participantAmount.value, cols: 6 }
      ];
    });

    // const customerPaymentStatus = uuid => (customerStatus.value || []).find(item => item.customerUuid === uuid)?.status;

    const customerAge = uuid => {
      const customer = (customersDetails.value || []).find(c => c?.uuid === uuid);
      if (!customer) {
        return '';
      }
      return differenceInYears(new Date(), new Date(customer.birth_date));
    };

    const computedSessionParticipants = computed(() => (props.session.participants || []).map(p => {
      const participant = { ...p };

      // participant.paymentColor = customerPaymentStatus(participant.uuid);
      participant.age = customerAge(participant.uuid);
      participant.fullname = `${participant.firstname} ${participant.lastname}`;
      return participant;
    }));

    const isSessionGroupe = computed(() => props.session.type === 'GROUPE');

    const sessions = computed(() => store.getters.dailySessions);

    const currentSession = computed(() => sessions.value.find(s => s.id === props.session.id));

    const preReservedParticipants = computed(() => (props?.session?.pre_reserved_participants?.items || []).map(p => ({ customer_id: p.customer_uuid, fullname: `${p.firstname} ${p.lastname}`, id: p.id })));

    const customersWithoutSession = computed(() => {
      const { with_session, without_session } = separateContentTypesWithAndWithoutSession('customer');

      const sessionsParticipants = currentSession.value ? currentSession.value.participants.map(p => ({ ...p, fullname: `${p.firstname} ${p.lastname}` })) : [];
      const customers = [...without_session, ...sessionsParticipants];

      const uuids = customers.map(c => c.uuid);

      with_session.map(customer => {
        if (uuids.includes(customer.uuid)) {
          return;
        }
        if (!customer.isAnnonymousCustomer || (customer.isAnnonymousCustomer && customer.uuid.includes(props.session.id))) {
          customers.push(customer);
        }
      });
      return sortArray(customers, 'fullname');
    });

    const getHorsedetail = uuid => store.getters.horse(uuid);

    /**
     * available horses received 3 args
     * 1º - the session
     * 2º - keepCurrentSession (boolean  if we want to keep the current session content type)
     * 3º - removeInstructorHorse (boolean if we want to remove instructor horse)
     */
    const getAvailableHorses = computed(() => {
      const availableHorsesForSession = availableHorses(props.session, true, true);

      return filterHorse(availableHorsesForSession, horseWithoutParticipant.value, props.session, selectedHorseTypes.value, 'instructors', selectedLevels.value);
    });

    /* Get the true index of a participant/horse in the participantHorseList */
    const getResourcesTrueIndex = (participant) => (participantHorseList.value || []).findIndex(p => (participant.participant && participant.participant === p.participant) || (participant.horse && participant.horse === p.horse));

    const getNormalResources = computed(() => (participantHorseList.value || []).filter(p => !p.isClubParticipant || p.contractOwner));

    /* Club Participants */
    const expandedClubOwners = ref([]);

    const clubParticipantExists = computed(() => (participantHorseList.value || []).some(p => p.isClubParticipant));

    const getClubParticipants = (owner) => {
      if(!clubParticipantExists.value) return [];
      return (participantHorseList.value || []).filter(p => owner.participant && p.isClubParticipant && (p.passOwnerUuid === owner.participant) && !p.contractOwner);
    };

    const isClubExpanded = (contractNumber) => (expandedClubOwners.value || []).includes(contractNumber);

    const toggleClubParticipantsExpansion = (contractNumber) => {
      if (!contractNumber) return;

      const index = expandedClubOwners.value.findIndex(c => c === contractNumber);

      if (index !== -1) {
        expandedClubOwners.value.splice(index, 1);
        return;
      } 
      expandedClubOwners.value.push(contractNumber);
    };

    const injectClubPassOwners = () => {
      if(!clubParticipantExists.value) return;
      
      (customersDetails.value || []).forEach(customer => {
        const index = participantHorseList.value.findIndex(list => list.participant !== customer.uuid && list.passOwnerUuid === customer.uuid);
        if (index !== -1 && !participantHorseList.value.some(list => list.participant === customer.uuid)) {
          participantHorseList.value.push({
            horse: null,
            participant: customer.uuid,
            participantLastname: customer.lastname,
            participantFullname: `${customer.firstname} ${customer.lastname}`,
            presence: '',
            presence_status: '',
            contract_number: participantHorseList.value[index].contract_number,
            age: customerAge(customer.uuid),
            isClubParticipant: true,
            contractOwner: true,
            passOwnerUuid: customer.uuid,
            notInSession: true
          });
        }
      });
      participantHorseList.value = sortArray(participantHorseList.value, 'participantLastname');
    };

    const resetValues = () => {
      const previousSelectedHorse = JSON.parse(JSON.stringify(horsesSelected.value));
      horsesSelected.value = [];
      participantsSelected.value = [];
      participantHorseList.value = [];
      resetRecurringState();
      
      // populate participant horse list with horses
      props.session.horses.filter(horse => !horse.isInstructorHorse).map(h => {
        const horse = getHorsedetail(h.uuid);

        if (horse) {
          horsesSelected.value.push(horse);
          participantHorseList.value.push({
            horse: horse.uuid,
            participant: null
          });
        }
      });

      // verify if horse is still available
      previousSelectedHorse.map(horse => {
        if (!horsesSelected.value.some(h => h.uuid === horse.uuid)) {
          if (getAvailableHorses.value.some(h => h.uuid === horse.uuid)) {
            horsesSelected.value.push(horse);
          }
        }
      });

      (props.session.participants || []).map(p => {
        const participant = { ...p };
        participantsSelected.value.push(participant);

        // if participant have horse add the horse to participant
        if (participant.horse) {
          const index = participantHorseList.value.findIndex(list => list.horse === participant.horse);
          if (index !== -1) {
            participantHorseList.value[index].participant = participant.uuid;
            participantHorseList.value[index].participantLastname = participant.lastname;
            participantHorseList.value[index].participantFullname = `${participant.firstname} ${participant.lastname}`;
            participantHorseList.value[index].presence = participant.presence;
            participantHorseList.value[index].presence_status = participant.presence_status;
            // participantHorseList.value[index].paymentColor = customerPaymentStatus(participant.uuid);
            participantHorseList.value[index].contract_number = participant.contract_number;
            participantHorseList.value[index].age = customerAge(participant.uuid);
            participantHorseList.value[index].isClubParticipant = participant.isClubParticipant;
            participantHorseList.value[index].contractOwner = participant.contractOwner;
            participantHorseList.value[index].passOwnerUuid = participant.passOwnerUuid;
            participantHorseList.value[index].isGuest = participant.isGuest;

            return;
          }
        }
        participantHorseList.value.push({
          horse: null,
          participant: participant.uuid,
          participantLastname: participant.lastname,
          participantFullname: `${participant.firstname} ${participant.lastname}`,
          presence: participant.presence,
          presence_status: participant.presence_status,
          // paymentColor: customerPaymentStatus(participant.uuid),
          contract_number: participant.contract_number,
          age: customerAge(participant.uuid),
          isClubParticipant: participant.isClubParticipant,
          contractOwner: participant.contractOwner,
          passOwnerUuid: participant.passOwnerUuid,
          isGuest: participant.isGuest
        });
      });
      participantHorseList.value = sortArray(participantHorseList.value, 'participantLastname');
    };

    watch(() => props.session, () => {
      resetValues();
      injectClubPassOwners();
    });

    // hook
    onBeforeMount(async () => {
      isComponentLoading.value = true;
      
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }

      resetValues();

      if (!props.session?.participants || !props.session?.participants.length) {
        isComponentLoading.value = false;
        return;
      }

      const normalParticipantsUuids = [];
      const clubPassOwnerUuids = [];

      (props.session.participants || []).forEach(participant => {
        // Fetch info when contract owner is not in session
        if (participant.isClubParticipant && participant.passOwnerUuid && !clubPassOwnerUuids.includes(participant.passOwnerUuid) && !props.session.participants.some(p => p.uuid === participant.passOwnerUuid)) {
          clubPassOwnerUuids.push(participant.passOwnerUuid);
        }
        // Fetch info when participant is not a anonymous club participant
        if (!participant.isGuest) {
          normalParticipantsUuids.push(participant.uuid);
        }
      });

      const response = await getCustomersByUUids([...normalParticipantsUuids, ...clubPassOwnerUuids]);
      if (response?.success && response?.data?.items?.length) {
        customersDetails.value = response.data.items.filter(c => c);
        injectClubPassOwners();
      }

      // const promises = [getCustomersPaymentStatus((props.session.participants || []).filter(part => part.contract_number).map(p => ({ customerUuid: p.uuid, contractNumber: p.contract_number.toString() })))];

      // if (!store.state.isLazyLoaded.products) {
      //   promises.push(store.dispatch('getProducts'));
      // }

      // const [res] = await Promise.all(promises).catch(() => [[]]);
      // if (res?.data?.length) {
      //   customerStatus.value = res.data;
      // }
      isComponentLoading.value = false;
    });

    const getSessionCustomer = uuid => (props.session.participants || []).find(p => p.uuid === uuid);

    const resetRecurringState = () => {
      typeOfUpdate.value = 'SINGLE';
      typeOfAction.value = null;
      updateParams.value = {};
      showConfirmationModal.value = false;
    };

    const updateSession = async (proposedContentList = null, isSingleSelect = false) => {
      if(canAssignHorsesRecurring.value) {
        const listToCheck = proposedContentList || [];
        const currentSessionAssignedHorses = (props.session?.horses || []).filter(horse => ((props.session.participants || []).some(p => p.horse === horse.uuid)) || ((props.session.instructors || []).some(p => p.horse === horse.uuid))).map(h => h.uuid);
        const multipleHorses = [];
        let horseWithParticipant = {};

        listToCheck.forEach(list => {
          /* Contract owners from club pass feature (they don't exist on the session, only added as label) */
          if (list.notInSession) return;
          //if is multiple horses assign (!isSingleSelect) we check if the horse is already in session, if it is we do nothing
          if(!isSingleSelect && (props.session?.horses || []).some(h => h.uuid === list.horse)) return;
          //if is single horse assign (isSingleSelect) we do nothing when:
           //1. The horse is already in session in some participant or instructor (currentSessionAssignedHorses)
           //2. We did the assignment to the participant we wanted already (horseWithParticipant)
          if(isSingleSelect && (currentSessionAssignedHorses.includes(list.horse) || Object.keys(horseWithParticipant).length)) return;
          
          const horse = getHorsedetail(list.horse);
  
          if(!horse) return;
  
          if(isSingleSelect && list.participant){
            horseWithParticipant = {...horse, participant: list.participant};
            return;
          }
  
          multipleHorses.push(horse);
        });
  
        if (props.session.recurring && (multipleHorses.length || Object.keys(horseWithParticipant).length) && canAssignHorsesRecurring.value && !horseAssignRecurringAutoAction.value) {
          updateParams.value = { 
            contentType: 'horse',
            multipleHorses,
            horseWithParticipant,
            proposedContentList
          };
          typeOfAction.value = 'add';
          changeEditSessionOverlay(true);
          return;
        }
      }

      if(proposedContentList && proposedContentList.length) {
        participantHorseList.value = proposedContentList;
      }

      const sessionBody = { ...props.session };
      const instructorsHorses = sessionBody.horses.filter(h => h.isInstructorHorse);
      sessionBody.horses = instructorsHorses;
      sessionBody.participants = [];

      participantHorseList.value.forEach(list => {
        if (list.notInSession) return;

        const horse = getHorsedetail(list.horse);
        const participant = getSessionCustomer(list.participant);

        if (horse) {
          sessionBody.horses.push({
            uuid: horse.uuid,
            wtitle: horse.wtitle,
            isInstructorHorse: false
          });
        }
        if (participant) {
          const sessionContainsParticipant = props.session.participants && props.session.participants[participant.uuid];
          const participantToAdd = {
            ...participant,
            presence: sessionContainsParticipant ? props.session.participants[participant.uuid].presence : false,
            horse: list.horse
          };
          delete participantToAdd.fullname;
          sessionBody.participants.push(participantToAdd);
        }

        if (list.isAnnonymousCustomer) {
          const sessionContainsParticipant = props.session.participants && props.session.participants[list.customerDetail.uuid];
          const { wtype, ...participantDetail } = list.customerDetail;
          const participantToAdd = {
            ...participantDetail,
            presence: sessionContainsParticipant ? props.session.participants[list.customerDetail.uuid].presence : false,
            horse: list.horse
          };
          sessionBody.participants.push(participantToAdd);
        }
      });

      isComponentLoading.value = true;
      await updateSessionAmplify(sessionBody);
      isComponentLoading.value = false;
      sendNotification('success', 'Ressource ajoutée avec succès');
      resetValues();
    };

    const manageContents = async () => {
      changeEditSessionOverlay(false);
      const { contentType, multipleHorses, horseWithParticipant, proposedContentList } = updateParams.value;
      if (typeOfAction.value === 'add' && contentType === 'horse') {
        isComponentLoading.value = true;
        if (proposedContentList) {
          participantHorseList.value = proposedContentList;
        }

        try {
          if(multipleHorses && multipleHorses.length) {          
            const response = await addHorsesToSession(props.session.id, multipleHorses, typeOfUpdate.value, null, false);
            const notificationType = response ? 'success' : 'error';
            const notificationMessage = !response ? 'Une erreur s\'est produite lors de l\'ajout' :  'Ressource ajoutée avec succès';
            resetValues();
            isComponentLoading.value = false;
            sendNotification(notificationType, notificationMessage);
            return;
          }
          const startTime = typeOfUpdate.value !== 'ALL' ? props.session.start_time : props.session.recurring_start_date;
          const sessionsToUpdate = await constructSessionsBag(typeOfUpdate.value, props.session, startTime);
          const allSessionsValid = sessionsToUpdate.every(session => session.participants?.length && (session.participants || []).some(p => p && p.uuid === horseWithParticipant.participant && (!p.horse || p.horse === horseWithParticipant.uuid)));
          const response = await addHorsesToSession(props.session.id, [horseWithParticipant], allSessionsValid ? typeOfUpdate.value : 'SINGLE', null, false, false);
          const notificationType = response ? 'success' : 'error';
          const notificationMessage = !response ? 'Une erreur s\'est produite lors de l\'ajout' :  allSessionsValid ? 'Ressource ajoutée avec succès' : 'Cheval a été ajouté uniquement à cette session';
          resetValues();
          isComponentLoading.value = false;
          sendNotification(notificationType, notificationMessage);
        } catch (error) {
          console.error('Error adding content to recurring session:', error);
          sendNotification('error', 'Une erreur s\'est produite lors de l\'ajout');
        }
      }
    };

    const computeDateLabel = computed(() => {
      const date = format(fromUnixTime(props.session.start_time), 'dd-MM-yyyy (EEEE)', { locale: fr });
      const startTime = format(fromUnixTime(props.session.start_time), 'HH:mm');
      const endTime = format(fromUnixTime(props.session.end_time), 'HH:mm');
      return `${date} [${startTime}h - ${endTime}h]`;
    });

    const computeInstructorsLabel = computed(() => {
      const instructorsNames = (props.session.instructors || []).map(instructor => {
        const getInstructorDetail = store.getters.instructor(instructor.uuid);
        return getInstructorDetail?.fullname;
      });
      return instructorsNames.filter(h => h);
    });

    const computeParticipantList = computed(() => participantHorseList.value.map(item => ({
      participant: item.participantFullname || '--',
      horse: item.horse ? getHorsedetail(item.horse)?.horse_name : '--'
    })));

    const headersParticipants = computed(() => (headers.value || []).map(header => ({ text: header.label && (header.counter != null) ? `${header.label} (${header.counter})` : null, key: header.key || null })).filter(h => h.text));

    const donwloadDataCSV = () => {
      const headersSession = [{ text: 'Nom de la session' }, { text: 'Date/Heure' }, { text: 'Discipline' }, { text: 'Moniteur' }, { text: 'Lieu de pratique' }];

      const sessionValues = [{ sessionName: props.session.name, date: computeDateLabel.value || '--', discipline: props.session.discipline?.wtitle || '--', instructors: computeInstructorsLabel.value || '--', placeSession: props.session.place?.wtitle || '--' }];

      const sections = [{ headers: headersSession, data: sessionValues }, { headers: headersParticipants.value, data: computeParticipantList.value }];

      downloadCSV(sections, `Données de session - ${props.session.name}`);
    };

    const downloadDataPDF = () => {
      const sessionData = {
        name: { label: 'Nom de la session:', value: props.session.name },
        date: { label: 'Date/Heure:', value: computeDateLabel.value },
        discipline: { label: 'Discipline:', value: props.session.discipline?.wtitle || '--' },
        instructors: { label: 'Moniteur:', value: (computeInstructorsLabel.value || []).join(', ') || '--' },
        place: { label: 'Lieu de pratique:', value: props.session.place?.wtitle || '--' }
      };
      const participantsData = headersParticipants.value.map(header => ({
        label: header.text,
        value: computeParticipantList.value.map(contentType => contentType[header.key])
      }));

      downloadSessionPDF(sessionData, participantsData, `Données de session - ${props.session.name}`);
    };

    const removePreOrder = async participant => {
      let preReservationsToDelete = [{ reservationId: participant.id, sessionId: props.session.id }];

      isComponentLoading.value = true;
      sendNotification('info', 'Suppression de la pré-réservation pour la séance en cours.');

      if (props.session.recurring && props.session.recurring_uuid) {
        const response = await sessionsByRecurringUuid(props.session.recurring_uuid);
        preReservationsToDelete = [];
        response.map(session => {
          const part = session.pre_reserved_participants.items.find(p => p.customer_uuid === participant.customer_id);
          if (part) {
            preReservationsToDelete.push({ reservationId: part.id, sessionId: session.id });
          }
        });
      }
      const deleteResponse = await removePreReservations(preReservationsToDelete);

      isComponentLoading.value = false;

      if (!deleteResponse || (deleteResponse && !deleteResponse.success)) {
        return sendNotification('error', 'Une erreur s\'est produite lors de la tentative de suppression de sessions');
      }
      return sendNotification('success', 'Les sessions ont été supprimées avec succès');
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    provide('updateSession', updateSession);
    provide('participantHorseList', participantHorseList);
    provide('horseWithoutParticipant', horseWithoutParticipant);
    provide('selectedHorseTypes', selectedHorseTypes);
    provide('isComponentLoading', isComponentLoading);
    provide('levelsList', selectedLevels);
    provide('typeOfupdate', typeOfUpdate);

    return { removePreOrder, donwloadDataCSV, downloadDataPDF, canUserPerformAction, isComponentLoading, participantHorse, isSessionGroupe, customersWithoutSession, preReservedParticipants, computedSessionParticipants, headers, participantHorseList, participantsSelected, horsesSelected, horses, getAvailableHorses, updateSession, paymentStatus, customerAge, getClubParticipants, getResourcesTrueIndex, getNormalResources, clubParticipantExists, isClubExpanded, expandedClubOwners, toggleClubParticipantsExpansion, isEquestrianSession, showConfirmationModal, changeEditSessionOverlay, manageContents, editOverlayOptions, canAssignHorsesRecurring, updateParams, typeOfAction };
  }
};
</script>

<style scoped>
  .preReservedParticipant {
    background-color: lightgray;
  }

  .preReservedSeparator {
    background-color: darkgray;
  }

  .list-item:hover {
    background-color: #C71900;
    color: white !important;
  }
</style>
